import DashCard from "../../containers/dashcard";
import Othernav from "../../components/navs/othernav";
import "react-phone-input-2/lib/style.css";
import { useState } from "react";
import api from "../../utils/axiosConfig";
import toast from "react-hot-toast";
import withAuth from "../../components/user/withAuth";
import lock from "../../assets/lock.svg";
import eyeOpen from "../../assets/eye-open.svg";
import eyeSlash from "../../assets/eye-slash.svg";
import { Link } from "react-router-dom";

const PassUpdate = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setIsUpdating(true);

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      setIsUpdating(false);
      return;
    }

    try {
      const response = await api.post("/auth/change-password", {
        oldPassword: currentPassword,
        newPassword: newPassword,
      });

      if (response.status === 200) {
        toast.success("Password updated successfully");
      }
    } catch (error) {
      // console.log(error.response);
      toast.error(error.response.data.message);
    } finally {
      setIsUpdating(false);
    }
  }

  return (
    <div>
      <Othernav headerDetails="Update Password" navLink="/account/profile" />
      <DashCard className="max-w-4xl mx-auto p-4 md:mt-40">
        <form>
          <div className="flex flex-col items-center p-4 relative bottom-24 md:bottom-10">
            <div className="w-full p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Current Password */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
                  <div className="flex items-center rounded-2xl border border-gray-300 px-4 py-2 relative">
                    <img src={lock} alt="lock-icon" />
                    <input
                      type={showCurrentPassword ? "text" : "password"}
                      className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
                      value={currentPassword}
                      onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                      className="absolute right-4 focus:outline-none"
                    >
                      <img
                        src={showCurrentPassword ? eyeOpen : eyeSlash}
                        alt="toggle password visibility"
                      />
                    </button>
                  </div>
                </div>

                {/* New Password */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                  <div className="flex items-center rounded-2xl border border-gray-300 px-4 py-2 relative">
                    <img src={lock} alt="lock-icon" />
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      className="absolute right-4 focus:outline-none"
                    >
                      <img
                        src={showNewPassword ? eyeOpen : eyeSlash}
                        alt="toggle password visibility"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                {/* Confirm New Password */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
                  <div className="flex items-center rounded-2xl border border-gray-300 px-4 py-2 relative">
                    <img src={lock} alt="lock-icon" />
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="ml-2 flex-1 border-none bg-transparent text-accent outline-none py-2 px-4"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute right-4 focus:outline-none"
                    >
                      <img
                        src={showConfirmPassword ? eyeOpen : eyeSlash}
                        alt="toggle password visibility"
                      />
                    </button>
                
                  </div>
                  <p className="text-xs mt-4">
                    Can’t remember your current password?<span className="underline text-secondary font-semibold"><Link to="/auth/forgot-password">Reset Your Password</Link></span> 
                    </p>
                </div>
              </div>
              {/* Submit Button */}
              <button 
                type="submit" 
                className="w-full mt-6 bg-secondary text-green-400 py-3 rounded-lg hover:bg-green-500 hover:text-white"
                onClick={handleChangePassword}
                disabled={isUpdating}
              >
                {isUpdating ? "Updating..." : "Change Password"}
              </button>
            </div>
          </div>
        </form>
      </DashCard>
    </div>
  );
};

const PassUpdateWithAuth = withAuth(PassUpdate);
export default PassUpdateWithAuth;
